/**
 * @file Manages the message storage in local storage
 */

export type Message = {
  isMessagesUnread: boolean;
};

/**
 * Get the current Nav
 */
export function get(): Message | null {
  const msg = window.localStorage.getItem('msg');

  if (msg) {
    return JSON.parse(msg);
  }

  return null;
}

/**
 * Set the Nav
 *
 * @param nav
 */
export function set(nav: Message) {
  window.localStorage.setItem('msg', JSON.stringify(nav));
}

/**
 * Remove the nav
 */
export function remove() {
  window.localStorage.removeItem('msg');
}
